import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const get = (path) => axios.get(`${API}${path}`).then((r) => r.data);

export const api = {
  home: () => get("/home"),
  services: () => get("/services"),
  service: (slug) => get(`/services/${slug}`),
  cities: () => get("/cities"),
  city: (slug) => get(`/cities/${slug}`),
  combo: (city, service) => get(`/cities/${city}/services/${service}`),
  region: (slug) => get(`/regions/${slug}`),
  insights: () => get("/insights"),
  insight: (slug) => get(`/insights/${slug}`),
  sectors: () => get("/sectors"),
  sector: (slug) => get(`/sectors/${slug}`),
  sectorCity: (sector, city) => get(`/sectors/${sector}/cities/${city}`),
  coverage: (q) => get(`/coverage?q=${encodeURIComponent(q)}`),
};

export function useApi(fn, deps) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState({ data: null, loading: true, error: null });
    fn()
      .then((data) => alive && setState({ data, loading: false, error: null }))
      .catch((error) => alive && setState({ data: null, loading: false, error }));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}
